import { render, staticRenderFns } from "./process-approval.vue?vue&type=template&id=42f56550&scoped=true"
import script from "./process-approval.vue?vue&type=script&lang=js"
export * from "./process-approval.vue?vue&type=script&lang=js"
import style0 from "./process-approval.vue?vue&type=style&index=0&id=42f56550&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f56550",
  null
  
)

export default component.exports